import { ComboboxButton, ComboboxButtonProps } from '@headlessui/react';
import { ReactNode, forwardRef } from 'react';
import { MdSearch } from 'react-icons/md';
import { comboboxStyles } from './headlessHelpers';

type JoreComboboxButtonProps = Omit<
  ComboboxButtonProps,
  'as' | 'children' | 'className'
> & {
  readonly className?: string;
  readonly children?: ReactNode;
  readonly testId?: string;
};

export const JoreComboboxButton = forwardRef<
  HTMLButtonElement,
  JoreComboboxButtonProps
>(({ children, className, testId, ...internalProps }, ref) => {
  return (
    <ComboboxButton
      ref={ref}
      data-testid={testId}
      className={comboboxStyles.button(className)}
      {...internalProps}
    >
      {children}
      <MdSearch className="mr-1 text-2xl text-tweaked-brand" />
      <i
        className="icon-arrow mx-1 text-tweaked-brand transition duration-150 ease-in-out ui-open:-rotate-180 ui-not-open:rotate-0"
        style={{ fontSize: 10 }}
      />
    </ComboboxButton>
  );
});

JoreComboboxButton.displayName = 'JoreComboboxButton';
